import { ArrowRight, Lock } from 'lucide-react';

import type { ChangeDetailOut } from '@/api/changeHistory';

function isJsonString(str: string | null): boolean {
  if (!str) return false;
  const trimmed = str.trim();
  if (!(trimmed.startsWith('{') || trimmed.startsWith('['))) return false;
  try {
    JSON.parse(trimmed);
    return true;
  } catch {
    return false;
  }
}

function ValueCell({ value }: { value: string | null }) {
  if (value === null || value === undefined) {
    return <span className="text-muted-foreground">(vazio)</span>;
  }
  if (isJsonString(value)) {
    return (
      <pre className="max-h-32 max-w-xs overflow-auto rounded border border-[var(--color-divider)] bg-[var(--color-bg-elevated)] p-1.5 font-mono text-[11px] leading-relaxed">
        {JSON.stringify(JSON.parse(value), null, 2)}
      </pre>
    );
  }
  return <span className="break-all">{value}</span>;
}

export function ChangeDetailTable({ details }: { details: ChangeDetailOut[] }) {
  if (details.length === 0) {
    return (
      <p className="py-2 text-xs text-muted-foreground">
        Nenhuma mudança de campo registrada (evento de criação).
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-[var(--color-divider)] text-left">
            <th className="pb-1.5 pr-3 font-medium text-muted-foreground">Campo</th>
            <th className="pb-1.5 pr-3 font-medium text-muted-foreground">Valor anterior</th>
            <th className="pb-1.5 pr-3 font-medium text-muted-foreground" aria-label="seta" />
            <th className="pb-1.5 pr-3 font-medium text-muted-foreground">Valor novo</th>
            <th className="pb-1.5 font-medium text-muted-foreground" aria-label="pii" />
          </tr>
        </thead>
        <tbody>
          {details.map((d) => (
            <tr key={d.id} className="border-b border-[var(--color-divider)] last:border-0">
              <td className="py-1.5 pr-3 font-mono font-medium">{d.field_name}</td>
              <td className="py-1.5 pr-3 font-mono">
                <ValueCell value={d.old_value} />
              </td>
              <td className="py-1.5 pr-3">
                <ArrowRight className="h-3 w-3 text-muted-foreground" />
              </td>
              <td className="py-1.5 pr-3 font-mono">
                <ValueCell value={d.new_value} />
              </td>
              <td className="py-1.5">
                {d.is_pii && (
                  <span
                    className="inline-flex items-center gap-0.5 rounded bg-amber-50 px-1 py-0.5 text-[11px] font-semibold text-amber-600 dark:bg-amber-950/40 dark:text-amber-400"
                    title="Dado pessoal (PII) — valor mascarado"
                  >
                    <Lock className="h-2.5 w-2.5" />
                    PII
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
